type SearchResultsHeaderProps = {
  /** The committed query the results belong to. */
  query: string
  /** How many rows the table is showing. */
  resultCount: number
  /** Total matches the backend counted, shown only when the result set was truncated. */
  totalCount: number
  /** True when the page cap stopped pagination before every match was fetched. */
  truncated: boolean
}

/**
 * SearchResultsHeader
 *
 * The `bar/search-results` row: replaces the folder breadcrumbs while results are showing. Only the
 * search term is emphasized. The count describes the rows on screen, so a truncated result set says
 * so rather than claiming a total it is not displaying.
 */
export function SearchResultsHeader({ query, resultCount, totalCount, truncated }: SearchResultsHeaderProps) {
  return (
    <p className="flex min-w-0 items-center gap-[3px] text-base font-medium leading-6 tracking-[-0.32px] text-brand-neutral-600">
      <span className="shrink-0 whitespace-nowrap">
        {truncated
          ? `Showing the first ${resultCount.toLocaleString()} of ${totalCount.toLocaleString()} search results for`
          : `${resultCount.toLocaleString()} ${resultCount === 1 ? 'Search result' : 'Search results'} for`}
      </span>
      <span className="truncate text-brand-neutral-950" title={query}>
        {query}
      </span>
    </p>
  )
}
